import * as React from "react";
import {useContext} from "react";


//css
import OverdraftChart from "./SummaryChart/OverdraftChart";
import BudgetChart from "./SummaryChart/BudgetChart";
import {Button, ButtonGroup} from "@progress/kendo-react-buttons";
import {
    budgetKey,
    mainMessages,
    overdraftKey,
} from "../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import UserContext from "../common/UserContext";


const SummaryChart = (props) => {
    const {
        siteLanguageDefault,
    } = useContext(UserContext);

    const {
        showOverdraft,
        selectOverdraft,
        setSelectOverdraft,
    } = props

    const localization = useLocalization();
    return (
        <div>
            <BudgetChart hidden={true}/>

            {!showOverdraft && <BudgetChart/>}

            {showOverdraft && (
                <>
                    {selectOverdraft ? (<OverdraftChart/>) : (<BudgetChart/>)}
                    <ButtonGroup
                        width={"100%"}
                        className={'chart-select-button'}
                    >
                        <Button
                            togglable={true}
                            selected={!selectOverdraft}
                            themeColor={'tertiary'}
                            fillMode={!selectOverdraft ? "solid" : "outline"}
                            onClick={() => {
                                setSelectOverdraft(!selectOverdraft);
                            }}
                        >
                            {localization.toLanguageString(budgetKey, mainMessages[siteLanguageDefault][budgetKey])}
                        </Button>
                        <Button
                            togglable={true}
                            selected={selectOverdraft}
                            themeColor={'tertiary'}
                            fillMode={selectOverdraft ? "solid" : "outline"}
                            onClick={() => {
                                setSelectOverdraft(!selectOverdraft);
                            }}
                        >
                            {localization.toLanguageString(overdraftKey, mainMessages[siteLanguageDefault][overdraftKey])}
                        </Button>
                    </ButtonGroup>
                </>
            )}
        </div>
    )
};

export default SummaryChart;